import React, { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";
import { JourneyProvider, useJourney } from "@/context/JourneyContext";
import { api } from "@/lib/api";
import { ProgressRail } from "@/components/Navigation";
import Welcome from "@/stages/Welcome";
import Landing from "@/stages/Landing";
import InvestorDiscovery from "@/stages/InvestorDiscovery";
import InvestorProfile from "@/stages/InvestorProfile";
import InvestorLocations from "@/stages/InvestorLocations";
import InvestorFloorplan from "@/stages/InvestorFloorplan";
import InvestorFunding from "@/stages/InvestorFunding";
import InvestorReveal from "@/stages/InvestorReveal";
import Discovery from "@/stages/Discovery";
import LifeProfile from "@/stages/LifeProfile";
import Location from "@/stages/Location";
import Finance from "@/stages/Finance";
import Budget from "@/stages/Budget";
import Reveal from "@/stages/Reveal";
import Wealth from "@/stages/Wealth";
import FinanceAppointment from "@/stages/FinanceAppointment";
import Roadmap from "@/stages/Roadmap";
import Closing from "@/stages/Closing";
import Admin from "@/pages/Admin";
import CrmLogin from "@/pages/CrmLogin";
import CrmDashboard from "@/pages/CrmDashboard";
import ClientDetail from "@/pages/ClientDetail";
import { AuthProvider, ProtectedRoute } from "@/context/AuthContext";
import { RewardsBadge } from "@/components/RewardsBadge";
import { JourneyBar } from "@/components/JourneyBar";

const STAGE_COMPONENTS = {
  0: Welcome, 1: Discovery, 2: LifeProfile, 3: Location,
  4: Finance, 5: Budget, 6: Reveal, 7: Wealth,
  8: FinanceAppointment, 9: Roadmap, 10: Closing,
};

const INVESTOR_STAGE_COMPONENTS = {
  0: Welcome, 1: InvestorDiscovery, 2: InvestorProfile,
  3: InvestorLocations, 4: InvestorFloorplan, 5: InvestorFunding, 6: InvestorReveal,
};

function Experience() {
  const { session, stage, clientType } = useJourney();
  const [stages, setStages] = useState([]);

  useEffect(() => {
    api.stages().then((d) => setStages(d.stages)).catch(() => {});
  }, []);

  const isInvestor = clientType === "investor";
  const map = isInvestor ? INVESTOR_STAGE_COMPONENTS : STAGE_COMPONENTS;
  const StageComp = map[stage] || Welcome;
  const showLanding = !session && !clientType;

  return (
    <div className="App relative">
      <div className="ambient-glow" />
      <div className="tech-grid" />
      <div className="grain" />
      <JourneyBar />
      {session && stage > 0 && !isInvestor && <ProgressRail stages={stages} current={stage} />}
      {session && stage > 0 && !isInvestor && <RewardsBadge />}
      <AnimatePresence mode="wait">
        {showLanding ? <Landing key="landing" /> : <StageComp key={stage} />}
      </AnimatePresence>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route path="/" element={<JourneyProvider><Experience /></JourneyProvider>} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/crm/login" element={<AuthProvider><CrmLogin /></AuthProvider>} />
        <Route path="/crm" element={<AuthProvider><ProtectedRoute><CrmDashboard /></ProtectedRoute></AuthProvider>} />
        <Route path="/crm/clients/:id" element={<AuthProvider><ProtectedRoute><ClientDetail /></ProtectedRoute></AuthProvider>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
